import { useSyncExternalStore } from 'react'

/*
 * One shared clock for the whole app. Every live timer reads from it, so a
 * board full of washing cars still runs on a single interval. Timers are
 * always computed from saved timestamps, never by counting ticks, so they
 * stay correct after a refresh or when the phone wakes up.
 */

let current = 0
let timer: ReturnType<typeof setInterval> | null = null
const listeners = new Set<() => void>()

const tick = () => {
    current = Date.now()
    listeners.forEach(listener => listener())
}

const subscribe = (listener: () => void) => {
    listeners.add(listener)

    if (!timer) {
        current = Date.now()
        timer = setInterval(tick, 1000)
    }

    return () => {
        listeners.delete(listener)

        if (listeners.size === 0 && timer) {
            clearInterval(timer)
            timer = null
        }
    }
}

const read = (): number => {
    if (!current) current = Date.now()
    return current
}

const serverSnapshot = (): number => 0

/**
 * Returns the current time in milliseconds, updated every `resolution` ms.
 * It is 0 during server rendering and the first hydration pass, so callers
 * render a neutral placeholder until it is set.
 */
export const useNow = (resolution = 1000): number => useSyncExternalStore(
    subscribe,
    () => Math.floor(read() / resolution) * resolution,
    serverSnapshot
)
